var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPointer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "109.491 43.167 30.122 30.439",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9075_66765",
    x1: 132.117,
    y1: 50.6958,
    x2: 118.73,
    y2: 68.1535,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.000001, 0, 0, 1.000001, -0.20513, 0.093523)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D1A8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5581,
    stopColor: "#7240C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5888,
    stopColor: "#7240C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7551,
    stopColor: "#7240C6",
    stopOpacity: 0
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 134.795 47.094 L 129.429 69.679 L 114.31 58.084 L 134.795 47.094 Z",
    fill: "url(#paint2_linear_9075_66765)",
    transform: "matrix(0.778616, -0.627501, 0.627501, 0.778616, -9.063633, 91.082651)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointer);
export default __webpack_public_path__ + "static/media/pointer.0f6d3bffc142f5f74d27c46f54d1ff20.svg";
export { ForwardRef as ReactComponent };